import { createNewHandbookApi } from '@/api/handbookApi'
import { POSITION_PROPERTY_URL } from '@/api/handbook/position'
import { createHandbookResponseErrors } from '@/utils/error/responseErrors'

const FOLD_URL = `${POSITION_PROPERTY_URL}/folds`

const errors = createHandbookResponseErrors('загиб', 'загибов')

export const FoldApi = createNewHandbookApi(FOLD_URL, errors)
